import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SpiritService from "../services/spiritService";

// Add Spirit Process End
const addSpiritProcessState = {
  addSpiritProcessLoading: false,
  addSpiritProcessData: null,
  addSpiritProcessError: null,
};

const createSpiritData = createAsyncThunk("spirit/add", async () => {
  return await SpiritService.createSpiritApi();
});

const createSpiritReducer = createSlice({
  name: "addSpiritProcess",
  initialState: addSpiritProcessState,
  extraReducers: (builder) => {
    builder.addCase(createSpiritData.pending, (state) => {
      state.addSpiritProcessLoading = true;
    });
    builder.addCase(createSpiritData.fulfilled, (state, action) => {
      state.addSpiritProcessLoading = false;
      state.addSpiritProcessData = action.payload;
      state.addSpiritProcessError = "";
    });
    builder.addCase(createSpiritData.rejected, (state, action) => {
      state.addSpiritProcessLoading = false;
      state.addSpiritProcessData = null;
      state.addSpiritProcessError = action.error.message;
    });
  },
});

export const CreateSpiritReducer = createSpiritReducer.reducer;
export const CreateSpiritData = createSpiritData;
// Add Spirit Process End

// Get Spirit Process List Start
const getSpiritProcessList = {
  getSpiritProcessListLoading: true,
  getSpiritProcessListData: null,
  getSpiritProcessListError: null,
};

const getSpiritProcessListData = createAsyncThunk(
  "spirit/list",
  async (payload) => {
    return await SpiritService.getSpiritListApi(payload);
  },
);

const getSpiritProcessListReducer = createSlice({
  name: "getSpiritProcessList",
  initialState: getSpiritProcessList,
  extraReducers: (builder) => {
    builder.addCase(getSpiritProcessListData.pending, (state) => {
      state.getSpiritProcessListLoading = true;
    });
    builder.addCase(getSpiritProcessListData.fulfilled, (state, action) => {
      state.getSpiritProcessListLoading = false;
      state.getSpiritProcessListData = action.payload;
      state.getSpiritProcessListError = "";
    });
    builder.addCase(getSpiritProcessListData.rejected, (state, action) => {
      state.getSpiritProcessListLoading = false;
      state.getSpiritProcessListData = null;
      state.getSpiritProcessListError = action.error.message;
    });
  },
});

export const GetSpiritProcessListReducer = getSpiritProcessListReducer.reducer;
export const GetSpiritProcessListData = getSpiritProcessListData;
// Get Spirit Process List End

// Get Spirit Process By Id Start
const getSpiritProcessByIdState = {
  getSpiritProcessByIdLoading: false,
  getSpiritProcessByIdData: null,
  getSpiritProcessByIdError: null,
};

const getSpiritProcessDataById = createAsyncThunk(
  "spirit/processById",
  async (processId) => {
    return await SpiritService.getSpiritByIdApi(processId);
  },
);

const getSpiritProcessByIdReducer = createSlice({
  name: "getSpiritProcessById",
  initialState: getSpiritProcessByIdState,
  extraReducers: (builder) => {
    builder.addCase(getSpiritProcessDataById.pending, (state) => {
      state.getSpiritProcessByIdLoading = true;
    });
    builder.addCase(getSpiritProcessDataById.fulfilled, (state, action) => {
      state.getSpiritProcessByIdLoading = false;
      state.getSpiritProcessByIdData = action.payload;
      state.getSpiritProcessByIdError = "";
    });
    builder.addCase(getSpiritProcessDataById.rejected, (state, action) => {
      state.getSpiritProcessByIdLoading = false;
      state.getSpiritProcessByIdData = null;
      state.getSpiritProcessByIdError = action.error.message;
    });
  },
});

export const GetSpiritProcessByIdReducer = getSpiritProcessByIdReducer.reducer;
export const GetSpiritProcessDataById = getSpiritProcessDataById;
// Get Spirit Process By Id End

// Update Spirit Process By Id Start
const updateSpiritProcessByIdState = {
  updateSpiritProcessByIdLoading: false,
  updateSpiritProcessByIdData: null,
  updateSpiritProcessByIdError: null,
};

const updateSpiritProcessDataById = createAsyncThunk(
  "spirit/updateSpiritProcessById",
  async (payload) => {
    return await SpiritService.updateSpiritById(payload);
  },
);

const updateSpiritProcessByIdReducer = createSlice({
  name: "updateSpiritProcessById",
  initialState: updateSpiritProcessByIdState,
  extraReducers: (builder) => {
    builder.addCase(updateSpiritProcessDataById.pending, (state) => {
      state.updateSpiritProcessByIdLoading = true;
    });
    builder.addCase(updateSpiritProcessDataById.fulfilled, (state, action) => {
      state.updateSpiritProcessByIdLoading = false;
      state.updateSpiritProcessByIdData = action.payload;
      state.updateSpiritProcessByIdError = "";
    });
    builder.addCase(updateSpiritProcessDataById.rejected, (state, action) => {
      state.updateSpiritProcessByIdLoading = false;
      state.updateSpiritProcessByIdData = null;
      state.updateSpiritProcessByIdError = action.error.message;
    });
  },
});

export const UpdateSpiritProcessByIdReducer =
  updateSpiritProcessByIdReducer.reducer;
export const UpdateSpiritProcessDataById = updateSpiritProcessDataById;
// Get Spirit Process By Id End

// Add Spirit Logs By Id Start
const addSpiritLogsDataState = {
  addSpiritLogsDataLoading: false,
  addSpiritLogsData: null,
  addSpiritLogsDataError: null,
};

const addSpiritLogsData = createAsyncThunk(
  "spirit/spiritLogs",
  async (payload) => {
    return await SpiritService.createSpiritLogsApi(payload);
  },
);

const addSpiritLogsDataReducer = createSlice({
  name: "addSpiritLogs",
  initialState: addSpiritLogsDataState,
  extraReducers: (builder) => {
    builder.addCase(addSpiritLogsData.pending, (state) => {
      state.addSpiritLogsDataLoading = true;
    });
    builder.addCase(addSpiritLogsData.fulfilled, (state, action) => {
      state.addSpiritLogsDataLoading = false;
      state.addSpiritLogsData = action.payload;
      state.addSpiritLogsDataError = "";
    });
    builder.addCase(addSpiritLogsData.rejected, (state, action) => {
      state.addSpiritLogsDataLoading = false;
      state.addSpiritLogsData = null;
      state.addSpiritLogsDataError = action.error.message;
    });
  },
});

export const AddSpiritLogsDataReducer = addSpiritLogsDataReducer.reducer;
export const AddSpiritLogsData = addSpiritLogsData;
// Add Spirit Logs By Id End

// Update Spirit Logs By Id Start
const updateSpiritLogsByIdState = {
  updateSpiritLogsByIdLoading: false,
  updateSpiritLogsById: null,
  updateSpiritLogsByIdError: null,
};

const updateSpiritLogsById = createAsyncThunk(
  "spiritLogs/updateProcessById",
  async (payload) => {
    return await SpiritService.updateSpiritLogsApi(payload);
  },
);

const updateSpiritLogsByIdReducer = createSlice({
  name: "updateSpiritLogsById",
  initialState: updateSpiritLogsByIdState,
  extraReducers: (builder) => {
    builder.addCase(updateSpiritLogsById.pending, (state) => {
      state.updateSpiritLogsByIdLoading = true;
    });
    builder.addCase(updateSpiritLogsById.fulfilled, (state, action) => {
      state.updateSpiritLogsByIdLoading = false;
      state.updateSpiritLogsById = action.payload;
      state.updateSpiritLogsByIdError = "";
    });
    builder.addCase(updateSpiritLogsById.rejected, (state, action) => {
      state.updateSpiritLogsByIdLoading = false;
      state.updateSpiritLogsById = null;
      state.updateSpiritLogsByIdError = action.error.message;
    });
  },
});

export const UpdateSpiritLogsByIdReducer = updateSpiritLogsByIdReducer.reducer;
export const UpdateSpiritLogsById = updateSpiritLogsById;
// Update Spirit Logs By Id End

// Get Spirit Logs Data List Start
const getSpiritLogsProcessData = {
  getSpiritLogsDataLoading: true,
  getSpiritLogsDataData: null,
  getSpiritLogsDataError: null,
};

const getSpiritLogsDataData = createAsyncThunk(
  "spiritLogs/processList",
  async (payload) => {
    return await SpiritService.getSpiritLogsListApi(payload);
  },
);

const getSpiritProcessDataReducer = createSlice({
  name: "getSpiritLogsData",
  initialState: getSpiritLogsProcessData,
  extraReducers: (builder) => {
    builder.addCase(getSpiritLogsDataData.pending, (state) => {
      state.getSpiritLogsDataLoading = true;
    });
    builder.addCase(getSpiritLogsDataData.fulfilled, (state, action) => {
      state.getSpiritLogsDataLoading = false;
      state.getSpiritLogsDataData = action.payload;
      state.getSpiritLogsDataError = "";
    });
    builder.addCase(getSpiritLogsDataData.rejected, (state, action) => {
      state.getSpiritLogsDataLoading = false;
      state.getSpiritLogsDataData = null;
      state.getSpiritLogsDataError = action.error.message;
    });
  },
});

export const GetSpiritProcessDataReducer = getSpiritProcessDataReducer.reducer;
export const GetSpiritLogsDataData = getSpiritLogsDataData;
// Get Spirit Logs Data List End

// Add Waste Water Start
const defaultAddSpiritWasteWaterState = {
  addWasteWaterLoading: false,
  addWasteWaterData: null,
  addWasteWaterError: null,
};

const addSpiritWasteWaterData = createAsyncThunk(
  "spiritwastewater/add",
  async (payload) => {
    return await SpiritService.addWasteWaterData(payload);
  },
);

const addSpiritWasteWaterReducer = createSlice({
  name: "addSpiritWasteWater",
  initialState: defaultAddSpiritWasteWaterState,
  extraReducers: (builder) => {
    builder.addCase(addSpiritWasteWaterData.pending, (state) => {
      state.addWasteWaterLoading = true;
    });
    builder.addCase(addSpiritWasteWaterData.fulfilled, (state, action) => {
      state.addWasteWaterLoading = false;
      state.addWasteWaterData = action.payload;
      state.addWasteWaterError = "";
    });
    builder.addCase(addSpiritWasteWaterData.rejected, (state, action) => {
      state.addWasteWaterLoading = false;
      state.addWasteWaterData = null;
      state.addWasteWaterError = action.error.message;
    });
  },
});

export const AddSpiritWasteWaterReducer = addSpiritWasteWaterReducer.reducer;
export const AddSpiritWasteWaterData = addSpiritWasteWaterData;
// Add Waste Water End

// Update Waste Water Start
const updateSpiritWasteWaterState = {
  updateWasteWaterLoading: false,
  updateWasteWaterData: null,
  updateWasteWaterError: null,
};

const updateSpiritWasteWater = createAsyncThunk(
  "spiritwastewater/update",
  async (payload) => {
    return await SpiritService.updateWasteWater(payload);
  },
);

const updateSpiritWasteWaterReducer = createSlice({
  name: "updateSpiritWasteWaterReducer",
  initialState: updateSpiritWasteWaterState,
  extraReducers: (builder) => {
    builder.addCase(updateSpiritWasteWater.pending, (state) => {
      state.updateWasteWaterLoading = true;
    });
    builder.addCase(updateSpiritWasteWater.fulfilled, (state, action) => {
      state.updateWasteWaterLoading = false;
      state.updateWasteWaterData = action.payload;
      state.updateWasteWaterError = "";
    });
    builder.addCase(updateSpiritWasteWater.rejected, (state, action) => {
      state.updateWasteWaterLoading = false;
      state.updateWasteWaterData = null;
      state.updateWasteWaterError = action.error.message;
    });
  },
});

export const UpdateSpiritWasteWaterReducer =
  updateSpiritWasteWaterReducer.reducer;
export const UpdateSpiritWasteWater = updateSpiritWasteWater;
//Update Waste Water End

// Get Waste Water Data List Start
const defaultSpiritWasteWaterListData = {
  getWasteWaterListLoading: false,
  getWasteWaterListData: null,
  getWasteWaterListError: null,
};

const fetchSpiritWasteWaterList = createAsyncThunk(
  "spiritwastewater/wastewaterList",
  async (payload) => {
    return await SpiritService.getWasteWaterList(payload);
  },
);

const getSpiritWasteWaterListReducer = createSlice({
  name: "getSpiritWasteWaterListData",
  initialState: defaultSpiritWasteWaterListData,
  extraReducers: (builder) => {
    builder.addCase(fetchSpiritWasteWaterList.pending, (state) => {
      state.getWasteWaterListLoading = true;
    });
    builder.addCase(fetchSpiritWasteWaterList.fulfilled, (state, action) => {
      state.getWasteWaterListLoading = false;
      state.getWasteWaterListData = action.payload;
      state.getWasteWaterListError = "";
    });
    builder.addCase(fetchSpiritWasteWaterList.rejected, (state, action) => {
      state.getWasteWaterListLoading = false;
      state.getWasteWaterListData = null;
      state.getWasteWaterListError = action.error.message;
    });
  },
});

export const GetSpiritWasteWaterListReducer =
  getSpiritWasteWaterListReducer.reducer;
export const FetchSpiritWasteWaterList = fetchSpiritWasteWaterList;
// Get Waste Water Data List End

// Delete Spirit Waste Water Start
const deleteSpiritWasteWaterState = {
  deleteSpiritWasteWaterLoading: false,
  deleteSpiritWasteWaterData: null,
  deleteSpiritWasteWaterError: null,
};

const deleteSpiritWasteWater = createAsyncThunk(
  "spiritwastewater/delete",
  async (payload) => {
    return await SpiritService.deleteWasteWater(payload);
  }
);

const deleteSpiritWasteWaterReducer = createSlice({
  name: "deleteSpiritWasteWater",
  initialState: deleteSpiritWasteWaterState,
  extraReducers: (builder) => {
    builder.addCase(deleteSpiritWasteWater.pending, (state) => {
      state.deleteSpiritWasteWaterLoading = true;
    });
    builder.addCase(deleteSpiritWasteWater.fulfilled, (state, action) => {
      state.deleteSpiritWasteWaterLoading = false;
      state.deleteSpiritWasteWaterData = action.payload;
      state.deleteSpiritWasteWaterError = "";
    });
    builder.addCase(deleteSpiritWasteWater.rejected, (state, action) => {
      state.deleteSpiritWasteWaterLoading = false;
      state.deleteSpiritWasteWaterData = null;
      state.deleteSpiritWasteWaterError = action.error.message;
    });
  },
});

export const DeleteSpiritWasteWaterReducer =
  deleteSpiritWasteWaterReducer.reducer;
export const DeleteSpiritWasteWater = deleteSpiritWasteWater;
// Delete Spirit Waste Water End

// Send To Spirit Process Start
const sendToSpiritProcessState = {
  sendToSpiritProcessLoading: false,
  sendToSpiritProcess: null,
  sendToSpiritProcessError: null,
};

const sendToSpiritProcess = createAsyncThunk(
  "spirit/sendToSpiritProcess",
  async (payload) => {
    return await SpiritService.sendToSpiritProcessApi(payload);
  },
);

const sendToSpiritProcessReducer = createSlice({
  name: "sendToSpiritProcess",
  initialState: sendToSpiritProcessState,
  extraReducers: (builder) => {
    builder.addCase(sendToSpiritProcess.pending, (state) => {
      state.sendToSpiritProcessLoading = true;
    });
    builder.addCase(sendToSpiritProcess.fulfilled, (state, action) => {
      state.sendToSpiritProcessLoading = false;
      state.sendToSpiritProcess = action.payload;
      state.sendToSpiritProcessError = "";
    });
    builder.addCase(sendToSpiritProcess.rejected, (state, action) => {
      state.sendToSpiritProcessLoading = false;
      state.sendToSpiritProcess = null;
      state.sendToSpiritProcessError = action.error.message;
    });
  },
});

export const SendToSpiritProcessReducer = sendToSpiritProcessReducer.reducer;
export const SendToSpiritProcess = sendToSpiritProcess;
// Send To Spirit Process End


// Delete Spirit Sub Log Start
const deleteSpiritLogState = {
  deleteSpiritLogLoading: false,
  deleteSpiritLogData: null,
  deleteSpiritLogError: null,
};

const deleteSpiritLog = createAsyncThunk("spirit/delete", async (payload) => {
  return await SpiritService.deleteSpiritLog(payload);
});

const deleteSpiritLogReducer = createSlice({
  name: "deleteSpiritLogReducer",
  initialState: deleteSpiritLogState,
  extraReducers: (builder) => {
    builder.addCase(deleteSpiritLog.pending, (state) => {
      state.deleteSpiritLogLoading = true;
    });
    builder.addCase(deleteSpiritLog.fulfilled, (state, action) => {
      state.deleteSpiritLogLoading = false;
      state.deleteSpiritLogData = action.payload;
      state.deleteSpiritLogError = "";
    });
    builder.addCase(deleteSpiritLog.rejected, (state, action) => {
      state.deleteSpiritLogLoading = false;
      state.deleteSpiritLogData = null;
      state.deleteSpiritLogError = action.error.message;
    });
  },
});

export const DeleteSpiritLogReducer = deleteSpiritLogReducer.reducer;
export const DeleteSpiritLog = deleteSpiritLog;
// Delete Spirit Sub Log Start

// Get End of Run Cut Start
const defaultGetEndOfRunCutState = {
  getEndOfRunCutLoading: false,
  getEndOfRunCutData: null,
  getEndOfRunCutError: null,
};

const fetchEndOfRunCut = createAsyncThunk(
  "spirit/endOfRunCut",
  async (spiritProcessId) => {
    return await SpiritService.getEndOfRunCutApi(spiritProcessId);
  }
);

const getEndOfRunCutReducer = createSlice({
  name: "getEndOfRunCut",
  initialState: defaultGetEndOfRunCutState,
  extraReducers: (builder) => {
    builder.addCase(fetchEndOfRunCut.pending, (state) => {
      state.getEndOfRunCutLoading = true;
    });
    builder.addCase(fetchEndOfRunCut.fulfilled, (state, action) => {
      state.getEndOfRunCutLoading = false;
      state.getEndOfRunCutData = action.payload;
      state.getEndOfRunCutError = "";
    });
    builder.addCase(fetchEndOfRunCut.rejected, (state, action) => {
      state.getEndOfRunCutLoading = false;
      state.getEndOfRunCutData = null;
      state.getEndOfRunCutError = action.error.message;
    });
  },
});

export const GetEndOfRunCutReducer = getEndOfRunCutReducer.reducer;
export const FetchEndOfRunCut = fetchEndOfRunCut;
// Get End of Run Cut End

// Save End of Run Cut Start
const defaultSaveEndOfRunCutState = {
  saveEndOfRunCutLoading: false,
  saveEndOfRunCutData: null,
  saveEndOfRunCutError: null,
};

const saveEndOfRunCut = createAsyncThunk(
  "spirit/saveEndOfRunCut",
  async (payload) => {
    return await SpiritService.saveEndOfRunCutApi(payload);
  }
);

const saveEndOfRunCutReducer = createSlice({
  name: "saveEndOfRunCut",
  initialState: defaultSaveEndOfRunCutState,
  extraReducers: (builder) => {
    builder.addCase(saveEndOfRunCut.pending, (state) => {
      state.saveEndOfRunCutLoading = true;
    });
    builder.addCase(saveEndOfRunCut.fulfilled, (state, action) => {
      state.saveEndOfRunCutLoading = false;
      state.saveEndOfRunCutData = action.payload;
      state.saveEndOfRunCutError = "";
    });
    builder.addCase(saveEndOfRunCut.rejected, (state, action) => {
      state.saveEndOfRunCutLoading = false;
      state.saveEndOfRunCutData = null;
      state.saveEndOfRunCutError = action.error.message;
    });
  },
});

export const SaveEndOfRunCutReducer = saveEndOfRunCutReducer.reducer;
export const SaveEndOfRunCut = saveEndOfRunCut;
// Save End of Run Cut End